<div #divSpinner class="cargando" [style.display]="cargando ? '' : 'none'">
    <mat-spinner style="margin:0 auto; margin-top: 15%;"></mat-spinner>
</div>

<div>
    <app-agendar [jardinTutoria]="jardinTutoriaSelected" [simulacion]="simulacion" *ngIf="showAgenda"></app-agendar>
    <app-notas *ngIf="showNotas"></app-notas>
    <app-notas-pm *ngIf="showNotasPM"></app-notas-pm>
</div>
<div *ngIf="!showAgenda && !showNotas && !showNotasPM">

    <div class="projects mb-4">
        <div class="card">
            <div class="card-header header-background">
                <div class="row">
                    <div class="col-sm-3">
                        <h2>Acompañamiento Personalizado</h2>
                    </div>
                    <div class="col-sm-6" style="margin-top: -10px;">
                        <p style="text-align: left;font-style: normal;">
                            Revise aquí todos los materiales de capacitación disponibles para usted. Agende, revise y realice las acciones asociadas a los módulos de Acompañamiento personalizado.
                        </p>
                    </div>
                    <div class="col-sm-3 aula">
                        <img src="../../../../../assets/icons/ico_acomp-personal.png" alt="avatar">
                    </div>
                </div>
            </div>

            <div>
                <ul class="nav nav-tabs">
                    <li class="nav-item">
                        <a class="nav-link active" data-bs-toggle="tab" href="#plan-mejora">Etapa Plan de Mejora</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" data-bs-toggle="tab" href="#capacitacion">Etapa Capacitación</a>
                    </li>
                </ul>
                <div id="myTabContent" class="tab-content">

                    <div class="tab-pane fade show active" id="plan-mejora">

                        <div style="padding: 20px 50px;">

                            <div class="row">
<!--                                 <div class="col-sm-6" style="padding: 5px;">
                                </div> -->
                                <div class="col-sm-12" style="padding: 5px;">
                                    <div class="divTutoria">
                                        <div class="row">
                                            <div class="col-sm-2">
                                                <div class="form-image-title" style="display: inline-block;">
                                                    <img src="../../../../../assets/icons/ico_bloc-notas.png" alt="avatar">
                                                </div>
                                            </div>
                                            <div class="col-sm-6">
                                                <p style="text-align: left;font: normal normal bold 22px/25px Montserrat;letter-spacing: 0px;color: #EE366D;">Block de Notas</p>
                                                <p style="text-align: left;font: normal normal normal 14px/20px Hind Siliguri;letter-spacing: 0px;color: #30374B;">Utilice este espacio digital para consignar los hallazgos, aprendizajes o consultas que surjan de este proceso de formación.</p>
                                            </div>

                                            <div class="col-sm-4 text-align-right">
                                                <button type="button" class="btn btn-light btn-send" (click)="openNotasPM()"> Continuar</button>
                                            </div>


                                        </div>
                                    </div>
                                </div>


                                <!-- *************************************************SESSION1*********************************************************** -->
                                <div class="row">
                                    <div class="col-sm-12" style="padding: 5px;">

                                        <div class="divTutoria">

                                            <div class="row">
                                                <div class="col-sm-3">
                                                    <p class="dataFecha">Sesión 1</p>
                                                    <p class="dataSubRed" style="cursor: pointer;" *ngIf="isCollapsed2" (click)="collapse2.toggle()">Recursos de Apoyo</p>
                                                    <p class="dataSubRed" style="cursor: pointer;" *ngIf="!isCollapsed2" (click)="collapse2.toggle()">Recursos de Apoyo</p>
                                                </div>
                                                <div class="col-sm-1 ">
                                                    <button class="btn-collapser" *ngIf="isCollapsed2" alt="avatar" (click)="collapse2.toggle()" [attr.aria-expanded]="!isCollapsed2" aria-controls="collapseExample2"><i class="fas fa-plus"></i></button>
                                                    <button class="btn-collapser" *ngIf="!isCollapsed2" alt="avatar" (click)="collapse2.toggle()" [attr.aria-expanded]="!isCollapsed2" aria-controls="collapseExample2"><i class="fas fa-minus"></i></button>
                                                </div>
                                                <div class="col-sm-2">
                                                    <p *ngIf="!etapaPM1.idEstadoAgenda" class="estado1">No agendada</p>
                                                    <p *ngIf="etapaPM1.idEstadoAgenda > 0" [ngClass]="
                                                            {'estado1':etapaPM1.idEstadoAgenda === 0,
                                                            'estado2':etapaPM1.idEstadoAgenda === 1,
                                                            'estado3': etapaPM1.idEstadoAgenda === 2}">{{etapaPM1.estadoAgenda}}</p>
                                                </div>
                                                <div class="col-sm-2">
                                                    <p class="dataFecha" style="text-align: center;margin-top: 10px;">{{etapaPM1.fechaAgenda | date:'dd-MM-yyyy'}}</p>
                                                </div>
                                                <div class="col-sm-3" style="text-align: center;">
                                                    <button type="button" *ngIf="etapaPM1.idEstadoActa < 1 || !etapaPM1.idEstadoAgenda" class="btn btn-light btn-send" disabled> Acta</button>
                                                    <button type="button" *ngIf="etapaPM1.idEstadoActa === 1" (click)="validarActaPMModal(etapaPM1)" class="btn btn-light btn-send"> Firmar Acta</button>
                                                    <button type="button" *ngIf="etapaPM1.idEstadoActa === 2" (click)="revisarActaPMModal(etapaPM1)" class="btn btn-light btn-send"> Ver Acta</button>
                                                </div>




                                                <!-- SECCION COLAPSE -->
                                                <div class="row mt-2" #collapse2="ngbCollapse" [(ngbCollapse)]="isCollapsed2">
                                                    <br>
                                                    <div class="row">
                                                        <div class="col-sm-12">
                                                            <p class="content">Cápsulas</p>
                                                        </div>
                                                    </div>

                                                    <div class="row">
                                                        <div class="col-sm-12 divContainerData">
                                                            <img src="../../../../../assets/icons/JUNJI__video.svg">
                                                            <p (click)="verVideo('PMsesion1cap1')" class="dataFecha docTitle">Cápsula 1: PME como instrumento de planificación para la gestión educativa</p>
                                                        </div>
                                                    </div>

                                                    <br>
                                                    <div class="row ">
                                                        <div class="col-sm-12">
                                                            <p class="content">Documentos</p>
                                                        </div>
                                                    </div>


                                                    <div class="row">
                                                        <div class="col-sm-12 divContainerData">
                                                            <img src="../../../../../assets/icons/JUNJI__file.svg">
                                                            <p (click)="verVideo('PMsesion1ppt1')" class="dataFecha docTitle">Orientaciones PME-EP</p>
                                                            <!-- <a href="../../../../../assets/documentos/2021/sesion2/M2.pptx" class="dataFecha docTitle"> PPT Sesión 2 de Acompañamiento Personalizado</a> -->
                                                        </div>
                                                    </div>

                                                    <div class="row">
                                                        <div class="col-sm-12 divContainerData">
                                                            <img src="../../../../../assets/icons/JUNJI__file.svg">
                                                            <p (click)="verVideo('PMsesion1ppt2')" class="dataFecha docTitle">Guía metodológica PME-EP</p>
                                                            <!-- <a href="../../../../../assets/documentos/2021/sesion2/M2.pptx" class="dataFecha docTitle"> PPT Sesión 2 de Acompañamiento Personalizado</a> -->
                                                        </div>
                                                    </div>
                                                    <div class="row">
                                                        <div class="col-sm-12 divContainerData">
                                                            <img src="../../../../../assets/icons/JUNJI__file.svg">
                                                            <p (click)="verVideo('PMsesion1ppt3')" class="dataFecha docTitle">Estándares Indicativos EID-EP</p>
                                                            <!-- <a href="../../../../../assets/documentos/2021/sesion2/M2.pptx" class="dataFecha docTitle"> PPT Sesión 2 de Acompañamiento Personalizado</a> -->
                                                        </div>
                                                    </div>
                                                    <div class="row">
                                                        <div class="col-sm-12 divContainerData">
                                                            <img src="../../../../../assets/icons/JUNJI__file.svg">
                                                            <p (click)="verVideo('PMsesion1ppt4')" class="dataFecha docTitle">Orientaciones para la articulación de las herramientas de gestión EP</p>
                                                            <!-- <a href="../../../../../assets/documentos/2021/sesion2/M2.pptx" class="dataFecha docTitle"> PPT Sesión 2 de Acompañamiento Personalizado</a> -->
                                                        </div>
                                                    </div>

                                                    <br>
                                                    <div class="row ">
                                                        <div class="col-sm-12">
                                                            <p class="content">Material para JI clásicos</p>
                                                        </div>
                                                    </div>
                                                    <div class="row">
                                                        <div class="col-sm-12 divContainerData">
                                                            <img src="../../../../../assets/icons/JUNJI__file.svg">
                                                            <p (click)="verVideo('PM1MatClasic1')" class="dataFecha docTitle">Ppt módulo 1</p>
                                                        </div>
                                                    </div>
                                                    <div class="row">
                                                        <div class="col-sm-12 divContainerData">
                                                            <img src="../../../../../assets/icons/JUNJI__file.svg">
                                                            <a href="../../../../../assets/documentos/2021/sesion1/M1_EJERCICIOS_CLASIC.docx" class="dataFecha docTitle">Ejercicios módulo 1</a>
                                                        </div>
                                                    </div>
                                                    <div class="row">
                                                        <div class="col-sm-12 divContainerData">
                                                            <img src="../../../../../assets/icons/JUNJI__file.svg">
                                                            <p (click)="verVideo('PM1MatClasic2')" class="dataFecha docTitle">Wordwall</p>
                                                        </div>
                                                    </div>

                                                    <br>
                                                    <div class="row ">
                                                        <div class="col-sm-12">
                                                            <p class="content">Material para JI alternativos</p>
                                                        </div>
                                                    </div>
                                                    <div class="row">
                                                        <div class="col-sm-12 divContainerData">
                                                            <img src="../../../../../assets/icons/JUNJI__file.svg">
                                                            <p (click)="verVideo('PM1MatAlter1')" class="dataFecha docTitle">Ppt módulo 1</p>
                                                        </div>
                                                    </div>
                                                    <div class="row">
                                                        <div class="col-sm-12 divContainerData">
                                                            <img src="../../../../../assets/icons/JUNJI__file.svg">
                                                            <a href="../../../../../assets/documentos/2021/sesion1/M1_EJERCICIOS_ALTER.docx" class="dataFecha docTitle">Ejercicios módulo 1</a>
                                                        </div>
                                                    </div>

                                                    <div class="row mt-2">
                                                        <div class="col-sm-6 divContainerData">
                                                            <img src="../../../../../assets/icons/JUNJI_zoom.svg">
                                                            <a class="dataFecha docTitle" [attr.href]="etapaPM1.linkZoom" target="_blank">Link de la Reunión</a>
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!-- ************************************************* FIN SESSION1*********************************************************** -->
                                <!-- *************************************************SESSION2*********************************************************** -->
                                <div class="row">
                                    <div class="col-sm-12" style="padding: 5px;">

                                        <div class="divTutoria">
                                            <div class="row">
                                                <div class="col-sm-3">
                                                    <p class="dataFecha">Sesión 2</p>
                                                    <p class="dataSubRed" style="cursor: pointer;" *ngIf="isCollapsed3" (click)="collapse3.toggle()">Recursos de Apoyo</p>
                                                    <p class="dataSubRed" style="cursor: pointer;" *ngIf="!isCollapsed3" (click)="collapse3.toggle()">Recursos de Apoyo</p>
                                                </div>
                                                <div class="col-sm-1 ">
                                                    <button class="btn-collapser" *ngIf="isCollapsed3" alt="avatar" (click)="collapse3.toggle()" [attr.aria-expanded]="!isCollapsed3" aria-controls="collapseExample3"><i class="fas fa-plus"></i></button>
                                                    <button class="btn-collapser" *ngIf="!isCollapsed3" alt="avatar" (click)="collapse3.toggle()" [attr.aria-expanded]="!isCollapsed3" aria-controls="collapseExample3"><i class="fas fa-minus"></i></button>
                                                </div>
                                                <div class="col-sm-2">
                                                    <p *ngIf="!etapaPM2.idEstadoAgenda" class="estado1">No agendada</p>
                                                    <p *ngIf="etapaPM2.idEstadoAgenda > 0" [ngClass]="
                                                            {'estado1':etapaPM2.idEstadoAgenda === 0,
                                                            'estado2':etapaPM2.idEstadoAgenda === 1,
                                                            'estado3': etapaPM2.idEstadoAgenda === 2}">{{etapaPM2.estadoAgenda}}</p>
                                                </div>
                                                <div class="col-sm-2">
                                                    <p class="dataFecha" style="text-align: center;margin-top: 10px;">{{etapaPM2.fechaAgenda | date:'dd-MM-yyyy'}}</p>
                                                </div>
                                                <div class="col-sm-3" style="text-align: center;">
                                                    <button type="button" *ngIf="etapaPM2.idEstadoActa < 1 || !etapaPM2.idEstadoAgenda" class="btn btn-light btn-send" disabled> Acta</button>
                                                    <button type="button" *ngIf="etapaPM2.idEstadoActa === 1" (click)="validarActaPMModal(etapaPM2)" class="btn btn-light btn-send"> Firmar Acta</button>
                                                    <button type="button" *ngIf="etapaPM2.idEstadoActa === 2" (click)="revisarActaPMModal(etapaPM2)" class="btn btn-light btn-send"> Ver Acta</button>
                                                </div>

                                                <div class="row mt-2" #collapse3="ngbCollapse" [(ngbCollapse)]="isCollapsed3">

                                                    <div class="row">
                                                        <div class="col-sm-12">
                                                            <p class="content">Cápsulas</p>
                                                        </div>
                                                    </div>

                                                    <div class="row">
                                                        <div class="col-sm-12 divContainerData">
                                                            <img src="../../../../../assets/icons/JUNJI__video.svg">
                                                            <p (click)="verVideo('PMsesion2cap1')" class="dataFecha docTitle">Cápsula 2: Fase Estratégica del PME</p>
                                                        </div>
                                                    </div>

                                                    <br>
                                                    <div class="row ">
                                                        <div class="col-sm-12">
                                                            <p class="content">Material para JI clásicos</p>
                                                        </div>
                                                    </div>
                                                    <div class="row">
                                                        <div class="col-sm-12 divContainerData">
                                                            <img src="../../../../../assets/icons/JUNJI__file.svg">
                                                            <p (click)="verVideo('PM2MatClasic1')" class="dataFecha docTitle">Ppt módulo 2</p>
                                                        </div>
                                                    </div>
                                                    <div class="row">
                                                        <div class="col-sm-12 divContainerData">
                                                            <img src="../../../../../assets/icons/JUNJI__file.svg">
                                                            <a href="../../../../../assets/documentos/2021/sesion2/M2_EJERCICIOS_CLASIC.docx" class="dataFecha docTitle">Ejercicios módulo 2</a>
                                                        </div>
                                                    </div>

                                                    <br>
                                                    <div class="row ">
                                                        <div class="col-sm-12">
                                                            <p class="content">Material para JI alternativos</p>
                                                        </div>
                                                    </div>
                                                    <div class="row">
                                                        <div class="col-sm-12 divContainerData">
                                                            <img src="../../../../../assets/icons/JUNJI__file.svg">
                                                            <p (click)="verVideo('PM2MatAlter1')" class="dataFecha docTitle">Ppt módulo 2</p>
                                                        </div>
                                                    </div>
                                                    <div class="row">
                                                        <div class="col-sm-12 divContainerData">
                                                            <img src="../../../../../assets/icons/JUNJI__file.svg">
                                                            <a href="../../../../../assets/documentos/2021/sesion2/M2_EJERCICIOS_ALTER.docx" class="dataFecha docTitle">Ejercicios módulo 2</a>
                                                        </div>
                                                    </div>
                                                    <div class="row">
                                                        <div class="col-sm-12 divContainerData">
                                                            <img src="../../../../../assets/icons/JUNJI__file.svg">
                                                            <p (click)="verVideo('PM2MatAlter2')" class="dataFecha docTitle">Wordwall</p>
                                                        </div>
                                                    </div>

                                                    <div class="row mt-2">
                                                        <div class="col-sm-6 divContainerData">
                                                            <img src="../../../../../assets/icons/JUNJI_zoom.svg">
                                                            <a class="dataFecha docTitle" [attr.href]="etapaPM2.linkZoom" target="_blank">Link de la Reunión</a>
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                        <!-- *************************************************FIN SESSION2*********************************************************** -->
                                        <!-- *************************************************SESSION3********************************************************** -->
                                        <div class="row">
                                            <div class="col-sm-12" style="padding: 5px;">

                                                <div class="divTutoria">
                                                    <div class="row">
                                                        <div class="col-sm-3">
                                                            <p class="dataFecha">Sesión 3</p>
                                                            <p class="dataSubRed" style="cursor: pointer;" (click)="collapse4.toggle()">Recursos de Apoyo</p>
                                                        </div>
                                                        <div class="col-sm-1 t">
                                                            <button class="btn-collapser" *ngIf="isCollapsed4" alt="avatar" (click)="collapse4.toggle()" [attr.aria-expanded]="!isCollapsed4" aria-controls="collapseExample4"><i class="fas fa-plus"></i></button>
                                                            <button class="btn-collapser" *ngIf="!isCollapsed4" alt="avatar" (click)="collapse4.toggle()" [attr.aria-expanded]="!isCollapsed4" aria-controls="collapseExample4"><i class="fas fa-minus"></i></button>
                                                        </div>
                                                        <div class="col-sm-2">
                                                            <p *ngIf="!etapaPM3.idEstadoAgenda" class="estado1">No agendada</p>
                                                            <p *ngIf="etapaPM3.idEstadoAgenda > 0" [ngClass]="
                                                                    {'estado1':etapaPM3.idEstadoAgenda === 0,
                                                                    'estado2':etapaPM3.idEstadoAgenda === 1,
                                                                    'estado3': etapaPM3.idEstadoAgenda === 2}">{{etapaPM3.estadoAgenda}}</p>
                                                        </div>
                                                        <div class="col-sm-2">
                                                            <p class="dataFecha" style="text-align: center;margin-top: 10px;">{{etapaPM3.fechaAgenda | date:'dd-MM-yyyy'}}</p>
                                                        </div>
                                                        <div class="col-sm-3" style="text-align: center;">
                                                            <button type="button" *ngIf="etapaPM3.idEstadoActa < 1 || !etapaPM3.idEstadoAgenda" class="btn btn-light btn-send" disabled> Acta</button>
                                                            <button type="button" *ngIf="etapaPM3.idEstadoActa === 1" (click)="validarActaPMModal(etapaPM3)" class="btn btn-light btn-send"> Firmar Acta</button>
                                                            <button type="button" *ngIf="etapaPM3.idEstadoActa === 2" (click)="revisarActaPMModal(etapaPM3)" class="btn btn-light btn-send"> Ver Acta</button>
                                                        </div>




                                                        <div class="row mt-2" #collapse4="ngbCollapse" [(ngbCollapse)]="isCollapsed4">
                                                            <div class="row">

                                                                <div class="row ">
                                                                    <div class="col-sm-12">
                                                                        <p class="content">Cápsulas</p>
                                                                    </div>
                                                                </div>
                                                                <div class="row">
                                                                    <div class="col-sm-12 divContainerData">
                                                                        <img src="../../../../../assets/icons/JUNJI__video.svg">
                                                                        <p (click)="verVideo('PMsesion3cap1')" class="dataFecha docTitle">Cápsula 3: Planificación de metas y estrategias</p>
                                                                    </div>
                                                                </div>

                                                                <br>
                                                                <div class="row ">
                                                                    <div class="col-sm-12">
                                                                        <p class="content">Material para JI clásicos</p>
                                                                    </div>
                                                                </div>
                                                                <div class="row">
                                                                    <div class="col-sm-12 divContainerData">
                                                                        <img src="../../../../../assets/icons/JUNJI__file.svg">
                                                                        <p (click)="verVideo('PM3MatClasic1')" class="dataFecha docTitle">Ppt módulo 3</p>
                                                                    </div>
                                                                </div>
                                                                <div class="row">
                                                                    <div class="col-sm-12 divContainerData">
                                                                        <img src="../../../../../assets/icons/JUNJI__file.svg">
                                                                        <a href="../../../../../assets/documentos/2021/sesion3/M3_EJERCICIOS_CLASIC.docx" class="dataFecha docTitle">Ejercicios módulo 3</a>
                                                                    </div>
                                                                </div>

                                                                <br>
                                                                <div class="row ">
                                                                    <div class="col-sm-12">
                                                                        <p class="content">Material para JI alternativos</p>
                                                                    </div>
                                                                </div>
                                                                <div class="row">
                                                                    <div class="col-sm-12 divContainerData">
                                                                        <img src="../../../../../assets/icons/JUNJI__file.svg">
                                                                        <p (click)="verVideo('PM3MatAlter1')" class="dataFecha docTitle">Ppt módulo 3</p>
                                                                    </div>
                                                                </div>
                                                                <div class="row">
                                                                    <div class="col-sm-12 divContainerData">
                                                                        <img src="../../../../../assets/icons/JUNJI__file.svg">
                                                                        <a href="../../../../../assets/documentos/2021/sesion3/M3_EJERCICIOS_ALTER.docx" class="dataFecha docTitle">Ejercicios módulo 3</a>
                                                                    </div>
                                                                </div>

                                                                <div class="row mt-2">
                                                                    <div class="col-sm-6 divContainerData">
                                                                        <img src="../../../../../assets/icons/JUNJI_zoom.svg">
                                                                        <a class="dataFecha docTitle" [attr.href]="etapaPM3.linkZoom" target="_blank">Link de la Reunión</a>
                                                                    </div>
                                                                </div>

                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <!-- *************************************************FIN SESSION3*********************************************************** -->
                                            <!-- *************************************************SESSION4*********************************************************** -->
                                            <div class="row">
                                                <div class="col-sm-12" style="padding: 5px;">
                                                    <div class="divTutoria">
                                                        <div class="row">
                                                            <div class="col-sm-3">
                                                                <p class="dataFecha">Sesión 4</p>
                                                                <p class="dataSubRed" style="cursor: pointer;">Recursos de Apoyo</p>
                                                            </div>
                                                            <div class="col-sm-1 ">
                                                                <button class="btn-collapser" *ngIf="isCollapsed5" alt="avatar" (click)="collapse5.toggle()" [attr.aria-expanded]="!isCollapsed5" aria-controls="collapseExample5"><i class="fas fa-plus"></i></button>
                                                                <button class="btn-collapser" *ngIf="!isCollapsed5" alt="avatar" (click)="collapse5.toggle()" [attr.aria-expanded]="!isCollapsed5" aria-controls="collapseExample5"><i class="fas fa-minus"></i></button>
                                                            </div>
                                                            <div class="col-sm-2">
                                                                <p *ngIf="!etapaPM4.idEstadoAgenda" class="estado1">No agendada</p>
                                                                <p *ngIf="etapaPM4.idEstadoAgenda > 0" [ngClass]="
                                                                        {'estado1':etapaPM4.idEstadoAgenda === 0,
                                                                        'estado2':etapaPM4.idEstadoAgenda === 1,
                                                                        'estado3': etapaPM4.idEstadoAgenda === 2}">{{etapaPM4.estadoAgenda}}</p>
                                                            </div>
                                                            <div class="col-sm-2">
                                                                <p class="dataFecha" style="text-align: center;margin-top: 10px;">{{etapaPM4.fechaAgenda | date:'dd-MM-yyyy':'-0'}}</p>
                                                            </div>
                                                            <div class="col-sm-3" style="text-align: center;">
                                                                <button type="button" *ngIf="etapaPM4.idEstadoActa < 1 || !etapaPM4.idEstadoAgenda" class="btn btn-light btn-send" disabled> Acta</button>
                                                                <button type="button" *ngIf="etapaPM4.idEstadoActa === 1" (click)="validarActaPMModal(etapaPM4)" class="btn btn-light btn-send"> Firmar Acta</button>
                                                                <button type="button" *ngIf="etapaPM4.idEstadoActa === 2" (click)="revisarActaPMModal(etapaPM4)" class="btn btn-light btn-send"> Ver Acta</button>
                                                            </div>



                                                            <div class="row mt-2" #collapse5="ngbCollapse" [(ngbCollapse)]="isCollapsed5">
                                                                <div class="row">

                                                                    <div class="row ">
                                                                        <div class="col-sm-12">
                                                                            <p class="content">Cápsulas</p>
                                                                        </div>
                                                                    </div>


                                                                    <div class="row">
                                                                        <div class="col-sm-12 divContainerData">
                                                                            <img src="../../../../../assets/icons/JUNJI__video.svg">
                                                                            <p (click)="verVideo('PMsesion4cap1')" class="dataFecha docTitle">Cápsula 4: Planificación de Acciones</p>
                                                                        </div>
                                                                    </div>

                                                                    <br>
                                                                    <div class="row ">
                                                                        <div class="col-sm-12">
                                                                            <p class="content">Material para JI clásicos</p>
                                                                        </div>
                                                                    </div>
                                                                    <div class="row">
                                                                        <div class="col-sm-12 divContainerData">
                                                                            <img src="../../../../../assets/icons/JUNJI__file.svg">
                                                                            <p (click)="verVideo('PM4MatClasic1')" class="dataFecha docTitle">Ppt módulo 4</p>
                                                                        </div>
                                                                    </div>
                                                                    <div class="row">
                                                                        <div class="col-sm-12 divContainerData">
                                                                            <img src="../../../../../assets/icons/JUNJI__file.svg">
                                                                            <p (click)="verVideo('PM4MatClasic2')" class="dataFecha docTitle">Wordwall</p>
                                                                        </div>
                                                                    </div>

                                                                    <br>
                                                                    <div class="row ">
                                                                        <div class="col-sm-12">
                                                                            <p class="content">Material para JI alternativos</p>
                                                                        </div>
                                                                    </div>
                                                                    <div class="row">
                                                                        <div class="col-sm-12 divContainerData">
                                                                            <img src="../../../../../assets/icons/JUNJI__file.svg">
                                                                            <p (click)="verVideo('PM4MatAlter1')" class="dataFecha docTitle">Ppt módulo 4</p>
                                                                        </div>
                                                                    </div>
                                                                    <div class="row">
                                                                        <div class="col-sm-12 divContainerData">
                                                                            <img src="../../../../../assets/icons/JUNJI__file.svg">
                                                                            <a href="../../../../../assets/documentos/2021/sesion4/M4_EJERCICIOS_ALER.docx" class="dataFecha docTitle">Ejercicios módulo 4</a>
                                                                        </div>
                                                                    </div>
                                                                    <div class="row">
                                                                        <div class="col-sm-12 divContainerData">
                                                                            <img src="../../../../../assets/icons/JUNJI__file.svg">
                                                                            <p (click)="verVideo('PM4MatAlter2')" class="dataFecha docTitle">Wordwall</p>
                                                                        </div>
                                                                    </div>

                                                                    <div class="row mt-2">
                                                                        <div class="col-sm-6 divContainerData">
                                                                            <img src="../../../../../assets/icons/JUNJI_zoom.svg">
                                                                            <a class="dataFecha docTitle" [attr.href]="etapaPM4.linkZoom" target="_blank">Link de la Reunión</a>
                                                                        </div>
                                                                    </div>

                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <!-- *************************************************FIN SESSION4*********************************************************** -->
                                                </div>
                                            </div>
                                        </div>

                                    </div>

                                </div>
                            </div>

                        </div>
                    </div>
                    <div class="tab-pane fade show" id="capacitacion">
                        <div style="padding: 20px 50px;">
                            <div class="row">
                                <div class="col-sm-6" style="padding: 5px;">
                                    <div class="divTutoria">
                                        <div class="row">
                                            <div class="col-sm-6">
                                                <p class="dataFecha">Inducción grupal</p>
                                                <p class="dataSubRed" style="cursor: pointer;" *ngIf="isCollapsed1" (click)="collapse1.toggle()">Revisar 6 Recursos de Apoyo</p>
                                                <p class="dataSubRed" style="cursor: pointer;" *ngIf="!isCollapsed1" (click)="collapse1.toggle()">Revisar 6 Recursos de Apoyo</p>
                                            </div>

                                            <div class="col-sm-6 text-align-right">
                                                <button class="btn-collapser" *ngIf="isCollapsed1" alt="avatar" (click)="collapse1.toggle()" [attr.aria-expanded]="!isCollapsed1" aria-controls="collapseExample"><i class="fas fa-plus"></i></button>
                                                <button class="btn-collapser" *ngIf="!isCollapsed1" alt="avatar" (click)="collapse1.toggle()" [attr.aria-expanded]="!isCollapsed1" aria-controls="collapseExample"><i class="fas fa-minus"></i></button>
                                            </div>

                                            <div class="row mt-2" #collapse1="ngbCollapse" [(ngbCollapse)]="isCollapsed1">


                                                <div class="row ">
                                                    <div class="col-sm-12">
                                                        <p class="content">Cápsulas</p>
                                                    </div>
                                                </div>

                                                <div class="row">
                                                    <div class="col-sm-12 divContainerData">
                                                        <img src="../../../../../assets/icons/JUNJI__video.svg">
                                                        <p (click)="verVideo('intro1')" class="dataFecha docTitle">Presentación Institucional</p>
                                                    </div>
                                                </div>

                                                <div class="row">
                                                    <div class="col-sm-12 divContainerData">
                                                        <img src="../../../../../assets/icons/JUNJI__video.svg">
                                                        <p (click)="verVideo('intro2')" class="dataFecha docTitle">Resumen MGCEP 7ma versión</p>
                                                    </div>
                                                </div>

                                                <div class="row">
                                                    <div class="col-sm-12 divContainerData">
                                                        <img src="../../../../../assets/icons/JUNJI__interactive-file.svg">
                                                        <p (click)="verVideo('intro3')" class="dataFecha docTitle">MGCEP en el Contexto de Aseguramiento de Calidad</p>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-sm-12">
                                                        <p class="content">Documentos</p>
                                                    </div>
                                                </div>

                                                <div class="row ">
                                                    <div class="col-sm-12 divContainerData">
                                                        <img src="../../../../../assets/icons/JUNJI__file.svg">
                                                        <p (click)="verVideo('intro4')" class="dataFecha docTitle">Ppt Inducción grupal</p>
                                                    </div>
                                                </div>

                                                <div class="row">
                                                    <div class="col-sm-12 divContainerData">
                                                        <img src="../../../../../assets/icons/JUNJI__file.svg">
                                                        <p (click)="verVideo('intro5')" class="dataFecha docTitle">Manual MGCEP</p>
                                                    </div>
                                                </div>

                                                <div class="row">
                                                    <div class="col-sm-12 ">
                                                        <p class="content">Enlace de Video Inducción</p>
                                                    </div>
                                                </div>

                                                <div class="row">
                                                    <div class="col-sm-6 divContainerData">
                                                        <img src="../../../../../assets/icons/JUNJI__video.svg">
                                                        <p (click)="verVideo('intro6')" class="dataFecha docTitle">Video Inducción grupal</p>
                                                    </div>
                                                </div>


                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-sm-6" style="padding: 5px;">
                                    <div class="divTutoria">
                                        <div class="row">
                                            <div class="col-sm-2">
                                                <div class="form-image-title" style="display: inline-block;">
                                                    <img src="../../../../../assets/icons/ico_bloc-notas.png" alt="avatar">
                                                </div>
                                            </div>
                                            <div class="col-sm-6">
                                                <p style="text-align: left;font: normal normal bold 22px/25px Montserrat;letter-spacing: 0px;color: #EE366D;">Block de Notas</p>
                                                <p style="text-align: left;font: normal normal normal 14px/20px Hind Siliguri;letter-spacing: 0px;color: #30374B;">Utilice este espacio digital para consignar los hallazgos, aprendizajes o consultas que surjan de este proceso de formación.</p>
                                            </div>

                                            <div class="col-sm-4 text-align-right">
                                                <button type="button" class="btn btn-light btn-send" (click)="openNotas()"> Continuar</button>
                                            </div>


                                        </div>
                                    </div>
                                </div>

                                <!-- *************************************************SESSION1*********************************************************** -->
                                <div class="row">
                                    <div class="col-sm-12" style="padding: 5px;">

                                        <div class="divTutoria">

                                            <div class="row">
                                                <div class="col-sm-3">
                                                    <p class="dataFecha">Módulo 1</p>
                                                    <p class="dataSubRed" style="cursor: pointer;" *ngIf="isCollapsed2" (click)="collapse2.toggle()">Revisar 4 Recursos de Apoyo</p>
                                                    <p class="dataSubRed" style="cursor: pointer;" *ngIf="!isCollapsed2" (click)="collapse2.toggle()">Revisar 4 Recursos de Apoyo</p>
                                                </div>
                                                <div class="col-sm-1 ">
                                                    <button class="btn-collapser" *ngIf="isCollapsed2" alt="avatar" (click)="collapse2.toggle()" [attr.aria-expanded]="!isCollapsed2" aria-controls="collapseExample2"><i class="fas fa-plus"></i></button>
                                                    <button class="btn-collapser" *ngIf="!isCollapsed2" alt="avatar" (click)="collapse2.toggle()" [attr.aria-expanded]="!isCollapsed2" aria-controls="collapseExample2"><i class="fas fa-minus"></i></button>
                                                </div>
                                                <div class="col-sm-2">
                                                    <p [ngClass]=" 
                                                            {'estado1':jardinTutoria1.idEstadoTutoria === 147,
                                                            'estado2':jardinTutoria1.idEstadoTutoria === 148,
                                                            'estado3': jardinTutoria1.idEstadoTutoria === 149,
                                                             'estado4': jardinTutoria1.idEstadoTutoria === 154}">{{jardinTutoria1.estadoTutoria}}</p>
                                                </div>
                                                <div class="col-sm-2">
                                                    <p class="dataFecha" style="text-align: center;margin-top: 10px;">{{jardinTutoria1.fechaInicioTutoria | date:'dd/MM/yyyy'}}</p>
                                                </div>
                                                <div class="col-sm-3" style="text-align: center;">
                                                    <button type="button" *ngIf="jardinTutoria1.idEstadoTutoria === 147 " (click)="agendar(jardinTutoria1)" class="btn btn-light btn-send"> Agendar</button>
                                                    <button type="button" *ngIf="jardinTutoria1.idEstadoTutoria === 148" (click)="detalleAgendaModal(jardinTutoria1)" class="btn btn-light btn-send"> Ver</button>
                                                    <button type="button" *ngIf="jardinTutoria1.idEstadoTutoria === 149" (click)="validarActaModal(jardinTutoria1)" class="btn btn-light btn-send"> Revisar Acta</button>
                                                    <button type="button" *ngIf="jardinTutoria1.idEstadoTutoria === 154" (click)="showActaTutoria(jardinTutoria1)" class="btn btn-light btn-send"> Acta</button>

                                                </div>




                                                <!-- SECCION COLAPSE -->
                                                <div class="row mt-2" #collapse2="ngbCollapse" [(ngbCollapse)]="isCollapsed2">


                                                    <div class="row ">
                                                        <div class="col-sm-12">
                                                            <p class="content">Cápsulas</p>
                                                        </div>
                                                    </div>

                                                    <div class="row">
                                                        <div class="col-sm-12 divContainerData">
                                                            <img src="../../../../../assets/icons/JUNJI__video.svg">
                                                            <p (click)="verVideo('sesion1cap1')" class="dataFecha docTitle">Cápsula 1. MGCEP: Conceptos Básicos</p>
                                                        </div>
                                                    </div>

                                                    <div class="row">
                                                        <div class="col-sm-12 divContainerData">
                                                            <img src="../../../../../assets/icons/JUNJI__video.svg">
                                                            <p (click)="verVideo('sesion1cap2')" class="dataFecha docTitle">Cápsula 2: Etapa Capacitación</p>
                                                        </div>
                                                    </div>

                                                    <div class="row">
                                                        <div class="col-sm-12 divContainerData">
                                                            <img src="../../../../../assets/icons/JUNJI__video.svg">
                                                            <p (click)="verVideo('sesion1cap3')" class="dataFecha docTitle">Cápsula 3: Tour Virtual Web</p>
                                                        </div>
                                                    </div>

                                                    <div class="row ">
                                                        <div class="col-sm-12">
                                                            <p class="content">Documentos</p>
                                                        </div>
                                                    </div>

                                                    <div class="row">
                                                        <div class="col-sm-12 divContainerData">
                                                            <img src="../../../../../assets/icons/JUNJI__file.svg">
                                                            <p (click)="verVideo('sesion1ppt1')" class="dataFecha docTitle">PPT Sesión 1 de Acompañamiento Personalizado</p>
                                                            <!-- <a href="../../../../../assets/documentos/2021/sesion1/M1Gappd.pptx" class="dataFecha docTitle"> PPT Sesión 1 de Acompañamiento Personalizado</a> -->
                                                        </div>
                                                    </div>


                                                    <div class="row mt-2">
                                                        <div class="col-sm-6 divContainerData">
                                                            <img src="../../../../../assets/icons/JUNJI_zoom.svg">
                                                            <a class="dataFecha docTitle" [attr.href]="jardinTutoria1.linkZoom" target="_blank">Link de la Reunión</a>
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!-- ************************************************* FIN SESSION1*********************************************************** -->
                                <!-- *************************************************SESSION2*********************************************************** -->
                                <div class="row">
                                    <div class="col-sm-12" style="padding: 5px;">

                                        <div class="divTutoria">
                                            <div class="row">
                                                <div class="col-sm-3">
                                                    <p class="dataFecha">Módulo 2</p>
                                                    <p class="dataSubRed" style="cursor: pointer;" *ngIf="isCollapsed3" (click)="collapse3.toggle()">Revisar 8 Recursos de Apoyo</p>
                                                    <p class="dataSubRed" style="cursor: pointer;" *ngIf="!isCollapsed3" (click)="collapse3.toggle()">Revisar 8 Recursos de Apoyo</p>
                                                </div>
                                                <div class="col-sm-1 ">
                                                    <button class="btn-collapser" *ngIf="isCollapsed3" alt="avatar" (click)="collapse3.toggle()" [attr.aria-expanded]="!isCollapsed3" aria-controls="collapseExample3"><i class="fas fa-plus"></i></button>
                                                    <button class="btn-collapser" *ngIf="!isCollapsed3" alt="avatar" (click)="collapse3.toggle()" [attr.aria-expanded]="!isCollapsed3" aria-controls="collapseExample3"><i class="fas fa-minus"></i></button>
                                                </div>
                                                <div class="col-sm-2">
                                                    <p [ngClass]=" 
                                                            {'estado1':jardinTutoria2.idEstadoTutoria === 147,
                                                            'estado2':jardinTutoria2.idEstadoTutoria === 148,
                                                            'estado3': jardinTutoria2.idEstadoTutoria === 149,
                                                            'estado4': jardinTutoria2.idEstadoTutoria === 154}">{{jardinTutoria2.estadoTutoria}}</p>
                                                </div>
                                                <div class="col-sm-2">
                                                    <p class="dataFecha" style="text-align: center;margin-top: 10px;">{{jardinTutoria2.fechaInicioTutoria | date:'dd/MM/yyyy'}}</p>
                                                </div>
                                                <div class="col-sm-3" style="text-align: center;">
                                                    <button type="button" *ngIf="jardinTutoria2.idEstadoTutoria === 147 " (click)="agendar(jardinTutoria2)" class="btn btn-light btn-send"> Agendar</button>
                                                    <button type="button" *ngIf="jardinTutoria2.idEstadoTutoria === 148" (click)="detalleAgendaModal(jardinTutoria2)" class="btn btn-light btn-send"> Ver</button>
                                                    <button type="button" *ngIf="jardinTutoria2.idEstadoTutoria === 149" (click)="validarActaModal(jardinTutoria2)" class="btn btn-light btn-send"> Revisar Acta</button>
                                                    <button type="button" *ngIf="jardinTutoria2.idEstadoTutoria === 154" (click)="showActaTutoria(jardinTutoria2)" class="btn btn-light btn-send"> Acta</button>
                                                </div>



                                                <div class="row mt-2" #collapse3="ngbCollapse" [(ngbCollapse)]="isCollapsed3">

                                                    <div class="row ">
                                                        <div class="col-sm-12">
                                                            <p class="content">Cápsulas</p>
                                                        </div>
                                                    </div>

                                                    <div class="row">
                                                        <div class="col-sm-12 divContainerData">
                                                            <img src="../../../../../assets/icons/JUNJI__video.svg">
                                                            <p (click)="verVideo('sesion2cap1')" class="dataFecha docTitle">Cápsula 4: Planificación y Mejora Continua</p>
                                                        </div>
                                                    </div>

                                                    <div class="row ">
                                                        <div class="col-sm-12">
                                                            <p class="content">Documentos</p>
                                                        </div>
                                                    </div>

                                                    <div class="row">
                                                        <div class="col-sm-12 divContainerData">
                                                            <img src="../../../../../assets/icons/JUNJI__file.svg">
                                                            <p (click)="verVideo('sesion2ppt1')" class="dataFecha docTitle">PPT Sesión 2 de Acompañamiento Personalizado</p>
                                                            <!-- <a href="../../../../../assets/documentos/2021/sesion2/M2.pptx" class="dataFecha docTitle"> PPT Sesión 2 de Acompañamiento Personalizado</a> -->
                                                        </div>
                                                    </div>

                                                    <div class="row">
                                                        <div class="col-sm-12 divContainerData">
                                                            <img src="../../../../../assets/icons/JUNJI__file.svg">
                                                            <p (click)="verVideo('sesion2cap4')" class="dataFecha docTitle"> Orientaciones para elaborar el PEI </p>
                                                        </div>
                                                    </div>
                                                    <div class="row">
                                                        <div class="col-sm-12 divContainerData">
                                                            <img src="../../../../../assets/icons/JUNJI__file.svg">
                                                            <p (click)="verVideo('sesion2cap5')" class="dataFecha docTitle"> Proyecto Educativo Institucional Jardìn Infantil 2021 </p>
                                                        </div>
                                                    </div>
                                                    <div class="row">
                                                        <div class="col-sm-12 divContainerData">
                                                            <img src="../../../../../assets/icons/JUNJI__file.svg">
                                                            <p (click)="verVideo('sesion2cap6')" class="dataFecha docTitle"> Proyecto Educativo Institucional Programa Educativo Alternativo de Atención al Párvulo 2021 </p>
                                                        </div>
                                                    </div>

                                                    <div class="row">
                                                        <div class="col-sm-12 ">
                                                            <p class="content">Actividades</p>
                                                        </div>
                                                    </div>
                                                    <div class="row">
                                                        <div class="col-sm-12 divContainerData">
                                                            <img src="../../../../../assets/icons/JUNJI__file.svg">
                                                            <p (click)="verVideo('sesion2cap7')" class="dataFecha docTitle"> Ejercicio: Relacionando Áreas y Dimensiones del MGCEP </p>
                                                        </div>
                                                    </div>
                                                    <div class="row">
                                                        <div class="col-sm-12 divContainerData">
                                                            <img src="../../../../../assets/icons/JUNJI__file.svg">
                                                            <a href="../../../../../assets/documentos/2021/sesion2/EjercicioPEI.docx" class="dataFecha docTitle"> Ejercicio de  análisis del PEI</a>
                                                        </div>
                                                    </div>
                                                    <div class="row">
                                                        <div class="col-sm-12 divContainerData">
                                                            <img src="../../../../../assets/icons/JUNJI__file.svg">
                                                            <a href="../../../../../assets/documentos/2021/sesion2/PMC.docx" class="dataFecha docTitle">  Ejercicios Proceso de Mejora Continua</a>
                                                        </div>
                                                    </div>
                                                    <div class="row">
                                                        <div class="col-sm-12 divContainerData">
                                                            <img src="../../../../../assets/icons/JUNJI__file.svg">
                                                            <a href="../../../../../assets/documentos/2021/sesion2/PMC.docx" class="dataFecha docTitle">  Ejercicios Proceso de Mejora Continua</a>
                                                        </div>
                                                    </div>



                                                    <div class="row mt-2">
                                                        <div class="col-sm-6 divContainerData">
                                                            <img src="../../../../../assets/icons/JUNJI_zoom.svg">
                                                            <a class="dataFecha docTitle" [attr.href]="jardinTutoria2.linkZoom" target="_blank">Link de la Reunión</a>
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                        <!-- *************************************************FIN SESSION2*********************************************************** -->
                                        <!-- *************************************************SESSION3********************************************************** -->
                                        <div class="row">
                                            <div class="col-sm-12" style="padding: 5px;">

                                                <div class="divTutoria">
                                                    <div class="row">
                                                        <div class="col-sm-3">
                                                            <p class="dataFecha">Módulo 3</p>
                                                            <p class="dataSubRed" style="cursor: pointer;" (click)="collapse4.toggle()">Revisar 5 Recursos de Apoyo</p>
                                                        </div>
                                                        <div class="col-sm-1 t">
                                                            <button class="btn-collapser" *ngIf="isCollapsed4" alt="avatar" (click)="collapse4.toggle()" [attr.aria-expanded]="!isCollapsed4" aria-controls="collapseExample4"><i class="fas fa-plus"></i></button>
                                                            <button class="btn-collapser" *ngIf="!isCollapsed4" alt="avatar" (click)="collapse4.toggle()" [attr.aria-expanded]="!isCollapsed4" aria-controls="collapseExample4"><i class="fas fa-minus"></i></button>
                                                        </div>
                                                        <div class="col-sm-2">
                                                            <p [ngClass]=" 
                                                            {'estado1':jardinTutoria3.idEstadoTutoria === 147,
                                                            'estado2':jardinTutoria3.idEstadoTutoria === 148,
                                                            'estado3': jardinTutoria3.idEstadoTutoria === 149,
                                                            'estado4': jardinTutoria3.idEstadoTutoria === 154}">{{jardinTutoria3.estadoTutoria}}</p>
                                                        </div>
                                                        <div class="col-sm-2">
                                                            <p class="dataFecha" style="text-align: center;margin-top: 10px;">{{jardinTutoria3.fechaInicioTutoria | date:'dd/MM/yyyy'}}</p>
                                                        </div>
                                                        <div class="col-sm-3" style="text-align: center;">
                                                            <button type="button" *ngIf="jardinTutoria3.idEstadoTutoria === 147 " (click)="agendar(jardinTutoria3)" class="btn btn-light btn-send"> Agendar</button>
                                                            <button type="button" *ngIf="jardinTutoria3.idEstadoTutoria === 148" (click)="detalleAgendaModal(jardinTutoria3)" class="btn btn-light btn-send"> Ver</button>
                                                            <button type="button" *ngIf="jardinTutoria3.idEstadoTutoria === 149" (click)="validarActaModal(jardinTutoria3)" class="btn btn-light btn-send" ngbPopover="Debe revisar y enviar el acta para poder realizar la próxima sesión" popoverTitle="Debe Revisar"> Revisar Acta</button>
                                                            <button type="button" *ngIf="jardinTutoria3.idEstadoTutoria === 154" (click)="showActaTutoria(jardinTutoria3)" class="btn btn-light btn-send"> Acta</button>
                                                        </div>



                                                        <div class="row mt-2" #collapse4="ngbCollapse" [(ngbCollapse)]="isCollapsed4">
                                                            <div class="row">

                                                                <div class="row ">
                                                                    <div class="col-sm-12">
                                                                        <p class="content">Cápsulas</p>
                                                                    </div>
                                                                </div>
                                                                <div class="row">
                                                                    <div class="col-sm-12 divContainerData">
                                                                        <img src="../../../../../assets/icons/JUNJI__video.svg">
                                                                        <p (click)="verVideo('sesion3cap2')" class="dataFecha docTitle">Cápsula 5: Etapa Autoevaluación </p>
                                                                    </div>
                                                                </div>

                                                                <div class="row">
                                                                    <div class="col-sm-12 divContainerData">
                                                                        <img src="../../../../../assets/icons/JUNJI__video.svg">
                                                                        <p (click)="verVideo('sesion3cap3')" class="dataFecha docTitle">Cápsula 6: Metodología Rúbricas</p>
                                                                    </div>
                                                                </div>

                                                                <div class="row">
                                                                    <div class="col-sm-12 divContainerData">
                                                                        <img src="../../../../../assets/icons/JUNJI__video.svg">
                                                                        <p (click)="verVideo('sesion3cap4')" class="dataFecha docTitle">Cápsula 7: Medios de verificación</p>
                                                                    </div>
                                                                </div>


                                                                <div class="row ">
                                                                    <div class="col-sm-12">
                                                                        <p class="content">Documentos</p>
                                                                    </div>
                                                                </div>

                                                                <div class="row">
                                                                    <div class="col-sm-12 divContainerData">
                                                                        <img src="../../../../../assets/icons/JUNJI__file.svg">
                                                                        <p (click)="verVideo('sesion3cap1')" class="dataFecha docTitle"> Guía de Evaluación </p>
                                                                    </div>
                                                                </div>

                                                                <div class="col-sm-12 divContainerData">
                                                                    <img src="../../../../../assets/icons/JUNJI__file.svg">
                                                                    <p (click)="verVideo('sesion3cap5')" class="dataFecha docTitle"> PPT Módulo 3 de Acompañamiento Personalizado </p>
                                                                </div>


                                                                <div class="row">
                                                                    <div class="col-sm-12 ">
                                                                        <p class="content">Actividades</p>
                                                                    </div>
                                                                </div>




                                                                <div class="row mt-2">
                                                                    <div class="col-sm-6 divContainerData">
                                                                        <img src="../../../../../assets/icons/JUNJI_zoom.svg">
                                                                        <a class="dataFecha docTitle" [attr.href]="jardinTutoria3.linkZoom" target="_blank">Link de la Reunión</a>
                                                                    </div>
                                                                </div>

                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <!-- *************************************************FIN SESSION3*********************************************************** -->
                                            <!-- *************************************************SESSION4*********************************************************** -->
                                            <div class="row">
                                                <div class="col-sm-12" style="padding: 5px;">
                                                    <div class="divTutoria">
                                                        <div class="row">
                                                            <div class="col-sm-3">
                                                                <p class="dataFecha">Módulo 4</p>
                                                                <p class="dataSubRed" style="cursor: pointer;">Revisar 5 Recursos de Apoyo</p>
                                                            </div>
                                                            <div class="col-sm-1 ">
                                                                <button class="btn-collapser" *ngIf="isCollapsed5" alt="avatar" (click)="collapse5.toggle()" [attr.aria-expanded]="!isCollapsed5" aria-controls="collapseExample5"><i class="fas fa-plus"></i></button>
                                                                <button class="btn-collapser" *ngIf="!isCollapsed5" alt="avatar" (click)="collapse5.toggle()" [attr.aria-expanded]="!isCollapsed5" aria-controls="collapseExample5"><i class="fas fa-minus"></i></button>
                                                            </div>
                                                            <div class="col-sm-2">
                                                                <p [ngClass]=" 
                                                            {'estado1':jardinTutoria4.idEstadoTutoria === 147,
                                                            'estado2':jardinTutoria4.idEstadoTutoria === 148,
                                                            'estado3': jardinTutoria4.idEstadoTutoria === 149,
                                                            'estado4': jardinTutoria3.idEstadoTutoria === 154}">{{jardinTutoria4.estadoTutoria}}</p>
                                                            </div>
                                                            <div class="col-sm-2">
                                                                <p class="dataFecha" style="text-align: center;margin-top: 10px;">{{jardinTutoria4.fechaInicioTutoria | date:'dd/MM/yyyy'}}</p>
                                                            </div>
                                                            <div class="col-sm-3" style="text-align: center;">
                                                                <button type="button" *ngIf="jardinTutoria4.idEstadoTutoria === 147 " (click)="agendar(jardinTutoria4)" class="btn btn-light btn-send"> Agendar</button>
                                                                <button type="button" *ngIf="jardinTutoria4.idEstadoTutoria === 148" (click)="detalleAgendaModal(jardinTutoria4)" class="btn btn-light btn-send"> Ver</button>
                                                                <button type="button" *ngIf="jardinTutoria4.idEstadoTutoria === 149" (click)="validarActaModal(jardinTutoria4)" class="btn btn-light btn-send"> Revisar Acta</button>
                                                                <button type="button" *ngIf="jardinTutoria4.idEstadoTutoria === 154" (click)="showActaTutoria(jardinTutoria4)" class="btn btn-light btn-send"> Acta</button>
                                                            </div>




                                                            <div class="row mt-2" #collapse5="ngbCollapse" [(ngbCollapse)]="isCollapsed5">
                                                                <div class="row">

                                                                    <div class="row ">
                                                                        <div class="col-sm-12">
                                                                            <p class="content">Cápsulas</p>
                                                                        </div>
                                                                    </div>
                                                                    <div class="row">
                                                                        <div class="col-sm-12 divContainerData">
                                                                            <img src="../../../../../assets/icons/JUNJI__video.svg">
                                                                            <p (click)="verVideo('sesion4cap1')" class="dataFecha docTitle">Cápsula 8: Etapa Validación</p>
                                                                        </div>
                                                                    </div>
                                                                    <div class="row">
                                                                        <div class="col-sm-12 divContainerData">
                                                                            <img src="../../../../../assets/icons/JUNJI__video.svg">
                                                                            <p (click)="verVideo('sesion4cap2')" class="dataFecha docTitle">Cápsula 9: Aspectos formales de la reunión de validación</p>
                                                                        </div>
                                                                    </div>
                                                                    <div class="row">
                                                                        <div class="col-sm-12 divContainerData">
                                                                            <img src="../../../../../assets/icons/JUNJI__video.svg">
                                                                            <p (click)="verVideo('sesion4cap3')" class="dataFecha docTitle">Cápsula 10: Etapa Plan de Mejoramiento Educativo</p>
                                                                        </div>
                                                                    </div>

                                                                    <div class="row ">
                                                                        <div class="col-sm-12">
                                                                            <p class="content">Documentos</p>
                                                                        </div>
                                                                    </div>

                                                                    <div class="col-sm-12 divContainerData">
                                                                        <img src="../../../../../assets/icons/JUNJI__file.svg">
                                                                        <p (click)="verVideo('sesion4cap5')" class="dataFecha docTitle"> PPT Módulo 4 de Acompañamiento Personalizado </p>
                                                                    </div>

                                                                    <div class="row">
                                                                        <div class="col-sm-12 divContainerData">
                                                                            <img src="../../../../../assets/icons/JUNJI__file.svg">
                                                                            <p class="dataFecha docTitle" (click)="verVideo('sesion4doc1')">Instructivo uso de zoom para entrevista de validación</p>
                                                                        </div>
                                                                    </div>
                                                                    <div class="row">
                                                                        <div class="col-sm-12 ">
                                                                            <p class="content">Actividades</p>
                                                                        </div>
                                                                    </div>

                                                                    <div class="row">
                                                                        <div class="col-sm-12 divContainerData">
                                                                            <img src="../../../../../assets/icons/JUNJI__interactive-file.svg">
                                                                            <p (click)="verVideo('sesion4cap4')" class="dataFecha docTitle"> Recordando lo aprendido. </p>
                                                                        </div>
                                                                    </div>

                                                                    <div class="row mt-2">
                                                                        <div class="col-sm-6 divContainerData">
                                                                            <img src="../../../../../assets/icons/JUNJI_zoom.svg">
                                                                            <a class="dataFecha docTitle" [attr.href]="jardinTutoria4.linkZoom" target="_blank">Link de la Reunión</a>
                                                                        </div>
                                                                    </div>

                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <!-- *************************************************FIN SESSION4*********************************************************** -->
                                                </div>
                                            </div>
                                        </div>

                                    </div>

                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>

            <div class="card-body">
                <ng-template #modalContent let-close="close">
                    <div class="modal-header">
                        <h5 class="titulo-card-rojo" style="margin-left: 14px;">Detalle Agenda Tutoría</h5>
                        <button type="button" class="close" (click)="close()" style="background: none;border: none;font-size: xx-large;">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body" style="padding: 30px;">
                        <div>
                            Tutor(a):
                            <pre class="inputModalAgenda">{{ modalData?.jardinTutoria?.tutor  }}</pre>
                        </div>
                        <div>
                            Fecha:
                            <pre class="inputModalAgenda">{{ modalData?.jardinTutoria?.fechaInicioTutoria | date:'dd/MM/yyyy'}}</pre>
                        </div>
                        <div>
                            Hora:
                            <pre class="inputModalAgenda">{{ modalData?.jardinTutoria?.fechaInicioTutoria | date:'hh:mm'}}</pre>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-outline-secondary" (click)="close()" style="    background-color: #3E445E;
                            color: #FFFFFF;
                            padding: 10px;
                            margin-top: 10px;
                            padding-left: 15px;
                            padding-right: 15px;
                            margin-right: 15px;
                            margin-bottom: 10px;">
                            Cerrar
                        </button>
                    </div>
                </ng-template>



                <ng-template #modalValidarActa let-modal>
                    <div class="modal-header" style="padding: 0px 23px;" width="100%">
                        <h5 id="modalTitleUser" style="text-align: left;font: normal normal bold 26px/53px Montserrat;letter-spacing: 0px;color: #EE366D;">Acta Sesión de Acompañamiento Personalizado </h5>
                        <button type="button" (click)="closeMessage()" style="background: none;border: none;font-size: xx-large;">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body" style="padding: 0px 50px;" width="100%">

                        <div class="row">
                            <div class="col-sm-12 mt-2">
                                <p style="text-align: left; letter-spacing: 0px; color: #30374B;opacity: 1;">
                                    La presente acta respalda la realización de la sesión de Acompañamiento personalizado llevada a cabo por la Unidad educativa <b>{{modalDataActa?.dataJardin?.jardin}}</b> como parte de la etapa de Capacitación de la
                                    8ª aplicación del Modelo de Gestión de Calidad de la Educación Parvularia.
                                </p>
                                <p>
                                    El acta que se presenta a continuación, sintetiza información relevante de la sesión realizada por la Unidad Educativa: <b>{{modalDataActa?.dataJardin?.jardin}}</b> como parte de la 8ª aplicación del Modelo de Gestión
                                    de la Calidad de la Educación Parvularia.
                                </p>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-sm-12 mt-2">
                                <p class="alert-div">Debe enviar esta acta al final de esta ventana para poder realizar la próxima sesión</p>
                            </div>
                        </div>


                        <div>


                            <div class="row mt-3">
                                <div class="col-sm-8 ">
                                    <p class="table-row-title">NÚMERO DE PARTICIPANTES Y SU ROL:</p>
                                </div>
                                <div class="col-sm-4" style="text-align: right;">
                                    <p style="display: inline-block;">N° Participantes:</p>
                                    <input type="number" class="form-control" [(ngModel)]="modalDataActa.datosActa.numeroParticipantes" style="padding: 6px 12px;width: 70px;display: inline-block;margin-left: 10px;" #numeroParticipantes disabled>
                                </div>
                            </div>



                            <div class="row mt-3">
                                <div class="col-sm-12 ">
                                    <table class="table table-hover">
                                        <thead>
                                            <tr>
                                                <th scope="col">Participante</th>
                                                <th scope="col">Rol</th>
                                            </tr>
                                        </thead>
                                        <tbody>

                                            <tr *ngFor="let participante of modalDataActa.datosActa.participantes">
                                                <td>{{participante.participante}}</td>
                                                <td>{{participante.rol}}</td>
                                            </tr>

                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>

                        <div class="row mt-3">
                            <div class="col-sm-12 ">
                                <p class="table-row-title">MÓDULOS CONTEMPLADOS:</p>
                            </div>
                        </div>

                        <div class="row mt-3">
                            <div class="col-sm-12 ">
                                <p style="text-align: left;
                font: normal normal normal 16px/28px Hind Siliguri;
                letter-spacing: 0px;
                color: #4C4D55;
                opacity: 1;">{{modalDataActa?.modulo}}</p>
                            </div>
                        </div>

                        <div class="row mt-3">
                            <div class="col-sm-12 ">
                                <p class="table-row-title">TIEMPOS:</p>
                            </div>
                        </div>


                        <div class="row mt-3">
                            <div class="col-sm-12 ">
                                <p style="display: inline-block;text-align: left;font: normal normal normal 16px/28px Hind Siliguri;letter-spacing: 0px;color: #4C4D55; opacity: 1;margin-left: 40px;">Fecha:</p>
                                <p style="padding: 8px 14px;display: inline-block;margin-left: 10px;background: #E8E8E8 0% 0% no-repeat padding-box; border-radius: 10px;">{{modalDataActa?.datosActa?.fechaInicio | date:'dd' }}</p>
                                <p style="padding: 8px 14px;display: inline-block;margin-left: 10px;background: #E8E8E8 0% 0% no-repeat padding-box; border-radius: 10px;">{{modalDataActa?.datosActa?.fechaInicio | date:'MM' }}</p>
                                <p style="padding: 8px 14px;display: inline-block;margin-left: 10px;background: #E8E8E8 0% 0% no-repeat padding-box; border-radius: 10px;">{{modalDataActa?.datosActa?.fechaInicio | date:'yyyy' }}</p>
                                <p style="display: inline-block;text-align: left;font: normal normal normal 16px/28px Hind Siliguri;letter-spacing: 0px;color: #4C4D55; opacity: 1;margin-left: 30px;">Inicio:</p>
                                <p style="padding: 8px 14px;display: inline-block;margin-left: 10px;background: #E8E8E8 0% 0% no-repeat padding-box; border-radius: 10px;">{{modalDataActa?.datosActa?.fechaInicio | date:'hh:mm' }}</p>
                                <p style="display: inline-block;text-align: left;font: normal normal normal 16px/28px Hind Siliguri;letter-spacing: 0px;color: #4C4D55; opacity: 1;margin-left: 30px;">Término:</p>
                                <p style="padding: 8px 14px;display: inline-block;margin-left: 10px;background: #E8E8E8 0% 0% no-repeat padding-box; border-radius: 10px;">{{modalDataActa?.datosActa?.fechaFin | date:'hh:mm' }}</p>
                            </div>
                        </div>

                        <div class="row mt-3">
                            <div class="col-sm-12 ">
                                <p class="table-row-title">OBSERVACIONES TUTOR:</p>
                            </div>
                        </div>

                        <div class="row mt-3">
                            <div class="col-sm-12">
                                <textarea class="text-area-comentario" disabled [(ngModel)]="modalDataActa.datosActa.comentarioTutor" style="background: #F5F6FC 0% 0% no-repeat padding-box;border-radius: 10px;opacity: 1;border: none;margin-bottom: 10px;width: 100%; height: 165px;padding: 10px;"></textarea>
                            </div>

                        </div>

                        <div class="row mt-3">
                            <div class="col-sm-12 ">
                                <p class="table-row-title">EVALUACIÓN DE LA SESIÓN</p>
                            </div>
                        </div>


                        <div class="row mt-3">
                            <div class="col-sm-12 ">
                                <p style="text-align: left;
                font: normal normal normal 16px/28px Hind Siliguri;
                letter-spacing: 0px;
                color: #4C4D55;
                opacity: 1;"> A continuación evalúe el desarrollo de la sesión. <b>Esta información no está disponible para el tutor o tutora.</b></p>

                                <table class="table table-hover">

                                    <tbody>

                                        <tr>
                                            <td>
                                                <p>1. La sesión de Acompañamiento personalizado se desarrolló en un clima de respeto y diálogo. </p>
                                            </td>
                                            <td>
                                                <input type="radio" name="1" id="1" class="with-gap" [value]="1" [(ngModel)]="modalDataActa.datosEncuestaActa.pregunta1"> SÍ
                                            </td>
                                            <td>
                                                <input type="radio" name="1" id="2" class="with-gap" [value]="0" [(ngModel)]="modalDataActa.datosEncuestaActa.pregunta1"> NO
                                            </td>
                                        </tr>

                                        <tr class="table-active">
                                            <td>
                                                <p>2. El tutor/a presenta conocimiento sobre todos los contenidos del módulo. </p>
                                            </td>
                                            <td>
                                                <input type="radio" name="2" id="1" class="with-gap" [value]="1" [(ngModel)]="modalDataActa.datosEncuestaActa.pregunta2"> SÍ
                                            </td>
                                            <td>
                                                <input type="radio" name="2" id="0" class="with-gap" [value]="0" [(ngModel)]="modalDataActa.datosEncuestaActa.pregunta2"> NO
                                            </td>
                                        </tr>

                                        <tr>
                                            <td>
                                                <p>3. La sesión de Acompañamiento personalizado se realiza a través de una metodología activa y de participación.</p>
                                            </td>
                                            <td>
                                                <input type="radio" name="3" id="1" class="with-gap" [value]="1" [(ngModel)]="modalDataActa.datosEncuestaActa.pregunta3"> SÍ
                                            </td>
                                            <td>
                                                <input type="radio" name="3" id="0" class="with-gap" [value]="0" [(ngModel)]="modalDataActa.datosEncuestaActa.pregunta3"> NO
                                            </td>
                                        </tr>

                                        <tr class="table-active">
                                            <td>
                                                <p>4. El tutor/a retroalimenta mencionando fortalezas y aspectos a mejorar en base a los ejercicios prácticos del módulo. </p>
                                            </td>
                                            <td>
                                                <input type="radio" name="4" id="1" class="with-gap" [value]="1" [(ngModel)]="modalDataActa.datosEncuestaActa.pregunta4"> SÍ
                                            </td>
                                            <td>
                                                <input type="radio" name="4" id="0" class="with-gap" [value]="0" [(ngModel)]="modalDataActa.datosEncuestaActa.pregunta4"> NO
                                            </td>
                                        </tr>

                                        <tr>
                                            <td>
                                                <p>5. Al inicio de la sesión de Acompañamiento personalizado se declaran los objetivos que orientan el trabajo del módulo. </p>
                                            </td>
                                            <td>
                                                <input type="radio" name="5" id="1" class="with-gap" [value]="1" [(ngModel)]="modalDataActa.datosEncuestaActa.pregunta5"> SÍ
                                            </td>
                                            <td>
                                                <input type="radio" name="5" id="0" class="with-gap" [value]="0" [(ngModel)]="modalDataActa.datosEncuestaActa.pregunta5"> NO
                                            </td>
                                        </tr>

                                        <tr class="table-active">
                                            <td>
                                                <p>6. Durante la sesión de Acompañamiento personalizado se dio espacio para solucionar consultas respecto de los contenidos del módulo. </p>
                                            </td>
                                            <td>
                                                <input type="radio" name="6" id="1" class="with-gap" [value]="1" [(ngModel)]="modalDataActa.datosEncuestaActa.pregunta6"> SÍ
                                            </td>
                                            <td>
                                                <input type="radio" name="6" id="0" class="with-gap" [value]="0" [(ngModel)]="modalDataActa.datosEncuestaActa.pregunta6"> NO
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>

                            </div>
                        </div>


                        <div class="row mt-3">
                            <div class="col-sm-12 ">
                                <p class="table-row-title">OBSERVACIONES DIRECTORA/ENCARGADA:</p>
                            </div>
                        </div>

                        <div class="row mt-3">
                            <div class="col-sm-12">
                                <textarea class="text-area-comentario" name="comentario" [(ngModel)]="modalDataActa.datosActa.comentarioJardin" #comentario='ngModel' style="background: #F5F6FC 0% 0% no-repeat padding-box;border-radius: 10px;opacity: 1;border: none;margin-bottom: 10px;width: 100%; height: 165px;padding: 10px;"></textarea>
                            </div>

                        </div>

                        <!-- <div class="errores" *ngIf="erores != ''" >
            <p class="table-row-title " style="color: #D8000C;">{{ erores }}</p>
        </div> -->

                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-send botonCalendario" style="margin: 5px;font-size: 16px;height: 45px;padding: 0px;" (click)="validarActa(modalDataActa)">Enviar</button>
                        <button type="button" class="btn btn-send botonCalendario" style="margin: 5px;font-size: 16px;height: 45px;background-color: #30374B;padding: 0px;" data-bs-dismiss="modal" (click)="close()">Cerrar</button>
                    </div>
                </ng-template>

                <ng-template #modalValidarActaPM let-modal>
                    <div class="modal-header" style="padding: 0px 23px;" width="100%">
                        <h5 id="modalTitleUser" style="text-align: left;font: normal normal bold 26px/53px Montserrat;letter-spacing: 0px;color: #EE366D;">Acta Sesión de Acompañamiento Personalizado </h5>
                        <button type="button" (click)="closeMessage()" style="background: none;border: none;font-size: xx-large;">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body" style="padding: 0px 50px;" width="100%">

                        <div class="row">
                            <div class="col-sm-12 mt-2" style="padding: 15px;">
                                <p style="text-align: left; letter-spacing: 0px; color: #30374B;opacity: 1;">
                                    La presente acta respalda la realización de la sesión de Acompañamiento personalizado llevada a cabo por la Unidad educativa <b>{{modalDataActa?.dataJardin?.jardin}}</b> como parte de la etapa de Capacitación de la
                                    8ª aplicación del Modelo de Gestión de Calidad de la Educación Parvularia.
                                </p>
                                <p>
                                    El acta que se presenta a continuación, sintetiza información relevante de la sesión realizada por la Unidad Educativa: <b>{{modalDataActa?.dataJardin?.jardin}}</b> como parte de la 8ª aplicación del Modelo de Gestión
                                    de la Calidad de la Educación Parvularia.
                                </p>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-sm-12 mt-2">
                                <p class="alert-div">Debe enviar esta acta al final de esta ventana para poder realizar la próxima sesión</p>
                            </div>
                        </div>


                        <div>


                            <div class="row mt-3">
                                <div class="col-sm-8 ">
                                    <p class="table-row-title">PARTICIPANTES Y SU ROL:</p>
                                </div>
                                <!--                                 <div class="col-sm-4" style="text-align: right;">
                                    <p style="display: inline-block;">N° Participantes: </p>
                                    <p style="display: inline-block;"> 2</p>
                                    <input type="number" class="form-control" [(ngModel)]="modalDataActaPM.datosActa.numeroParticipantes" style="padding: 6px 12px;width: 70px;display: inline-block;margin-left: 10px;" #numeroParticipantes disabled>
                                </div> -->
                            </div>
                            <div class="row mt-3">
                                <div class="col-sm-12 ">
                                    <table class="table table-hover">
                                        <thead>
                                            <tr>
                                                <th scope="col">Participante</th>
                                                <th scope="col">Rol</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>{{modalDataActaPM.datosActa.nombreTutor}}</td>
                                                <td>Tutor/a</td>
                                            </tr>
                                            <tr>
                                                <td>{{modalDataActaPM.datosActa.nombreDirectora}}</td>
                                                <td>Directora</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>

                        <div class="row mt-3">
                            <div class="col-sm-12 ">
                                <p class="table-row-title">MÓDULOS CONTEMPLADOS:</p>
                            </div>
                        </div>

                        <div class="row mt-3">
                            <div class="col-sm-12 ">
                                <p style="text-align: left;
                        font: normal normal normal 16px/28px Hind Siliguri;
                        letter-spacing: 0px;
                        color: #4C4D55;
                        opacity: 1;">{{modalDataActaPM?.modulo}}</p>
                            </div>
                        </div>

                        <div class="row mt-3">
                            <div class="col-sm-12 ">
                                <p class="table-row-title">TIEMPOS:</p>
                                <p style="text-align: left;
                                font: normal normal normal 16px/28px Hind Siliguri;
                                letter-spacing: 0px;
                                color: #4C4D55;
                                opacity: 1;">Escriba la fecha, horario y duración de la Entrevista de validación:</p>
                            </div>
                        </div>


                        <div class="row mt-3">
                            <div class="col-sm-12 ">
                                <p style="display: inline-block;text-align: left;font: normal normal normal 16px/28px Hind Siliguri;letter-spacing: 0px;color: #4C4D55; opacity: 1;margin-left: 40px;">Fecha:</p>
                                <p style="padding: 8px 14px;display: inline-block;margin-left: 10px;background: #E8E8E8 0% 0% no-repeat padding-box; border-radius: 10px;">{{modalDataActaPM?.datosActa?.fechaInicio | date:'dd' }}</p>
                                <p style="padding: 8px 14px;display: inline-block;margin-left: 10px;background: #E8E8E8 0% 0% no-repeat padding-box; border-radius: 10px;">{{modalDataActaPM?.datosActa?.fechaInicio | date:'MM' }}</p>
                                <p style="padding: 8px 14px;display: inline-block;margin-left: 10px;background: #E8E8E8 0% 0% no-repeat padding-box; border-radius: 10px;">{{modalDataActaPM?.datosActa?.fechaInicio | date:'yyyy' }}</p>
                                <p style="display: inline-block;text-align: left;font: normal normal normal 16px/28px Hind Siliguri;letter-spacing: 0px;color: #4C4D55; opacity: 1;margin-left: 30px;">Inicio:</p>
                                <p style="padding: 8px 14px;display: inline-block;margin-left: 10px;background: #E8E8E8 0% 0% no-repeat padding-box; border-radius: 10px;">{{modalDataActaPM?.datosActa?.fechaInicio | date:'HH:mm' }}</p>
                                <p style="display: inline-block;text-align: left;font: normal normal normal 16px/28px Hind Siliguri;letter-spacing: 0px;color: #4C4D55; opacity: 1;margin-left: 30px;">Término:</p>
                                <p style="padding: 8px 14px;display: inline-block;margin-left: 10px;background: #E8E8E8 0% 0% no-repeat padding-box; border-radius: 10px;">{{modalDataActaPM?.datosActa?.fechaFin | date:'HH:mm' }}</p>
                            </div>
                        </div>

                        <div class="row mt-3">
                            <div class="col-sm-12 ">
                                <p class="table-row-title">OBSERVACIONES TUTOR:</p>
                            </div>
                        </div>

                        <div class="row mt-3">
                            <div class="col-sm-12">
                                <textarea class="text-area-comentario" disabled [(ngModel)]="modalDataActaPM.datosActa.observacionTutor" style="background: #F5F6FC 0% 0% no-repeat padding-box;border-radius: 10px;opacity: 1;border: none;margin-bottom: 10px;width: 100%; height: 165px;padding: 10px;"></textarea>
                            </div>

                        </div>

                        <div class="row mt-3">
                            <div class="col-sm-12 ">
                                <p class="table-row-title">EVALUACIÓN DE LA SESIÓN</p>
                            </div>
                        </div>


                        <div class="row mt-3">
                            <div class="col-sm-12 ">
                                <p style="text-align: left;
                                font: normal normal normal 16px/28px Hind Siliguri;
                                letter-spacing: 0px;
                                color: #4C4D55;
                                opacity: 1;"> A continuación evalúe el desarrollo de la sesión. <b>Esta información no está disponible para el tutor o tutora.</b></p>

                                <table class="table table-hover">

                                    <tbody>

                                        <tr>
                                            <td>
                                                <p>1. La sesión de Acompañamiento personalizado se desarrolló en un clima de respeto y diálogo. </p>
                                            </td>
                                            <td>
                                                <input type="radio" name="1" id="1" class="with-gap" [value]="1" [(ngModel)]="modalDataActaPM.datosEncuestaActaPM.evaluacion1"> SÍ
                                            </td>
                                            <td>
                                                <input type="radio" name="1" id="2" class="with-gap" [value]="0" [(ngModel)]="modalDataActaPM.datosEncuestaActaPM.evaluacion1"> NO
                                            </td>
                                        </tr>

                                        <tr class="table-active">
                                            <td>
                                                <p>2. El tutor/a presenta conocimiento sobre todos los contenidos del módulo. </p>
                                            </td>
                                            <td>
                                                <input type="radio" name="2" id="1" class="with-gap" [value]="1" [(ngModel)]="modalDataActaPM.datosEncuestaActaPM.evaluacion2"> SÍ
                                            </td>
                                            <td>
                                                <input type="radio" name="2" id="0" class="with-gap" [value]="0" [(ngModel)]="modalDataActaPM.datosEncuestaActaPM.evaluacion2"> NO
                                            </td>
                                        </tr>

                                        <tr>
                                            <td>
                                                <p>3. La sesión de Acompañamiento personalizado se realiza a través de una metodología activa y de participación.</p>
                                            </td>
                                            <td>
                                                <input type="radio" name="3" id="1" class="with-gap" [value]="1" [(ngModel)]="modalDataActaPM.datosEncuestaActaPM.evaluacion3"> SÍ
                                            </td>
                                            <td>
                                                <input type="radio" name="3" id="0" class="with-gap" [value]="0" [(ngModel)]="modalDataActaPM.datosEncuestaActaPM.evaluacion3"> NO
                                            </td>
                                        </tr>

                                        <tr class="table-active">
                                            <td>
                                                <p>4. El tutor/a retroalimenta mencionando fortalezas y aspectos a mejorar en base a los ejercicios prácticos del módulo. </p>
                                            </td>
                                            <td>
                                                <input type="radio" name="4" id="1" class="with-gap" [value]="1" [(ngModel)]="modalDataActaPM.datosEncuestaActaPM.evaluacion4"> SÍ
                                            </td>
                                            <td>
                                                <input type="radio" name="4" id="0" class="with-gap" [value]="0" [(ngModel)]="modalDataActaPM.datosEncuestaActaPM.evaluacion4"> NO
                                            </td>
                                        </tr>

                                        <tr>
                                            <td>
                                                <p>5. Al inicio de la sesión de Acompañamiento personalizado se declaran los objetivos que orientan el trabajo del módulo. </p>
                                            </td>
                                            <td>
                                                <input type="radio" name="5" id="1" class="with-gap" [value]="1" [(ngModel)]="modalDataActaPM.datosEncuestaActaPM.evaluacion5"> SÍ
                                            </td>
                                            <td>
                                                <input type="radio" name="5" id="0" class="with-gap" [value]="0" [(ngModel)]="modalDataActaPM.datosEncuestaActaPM.evaluacion5"> NO
                                            </td>
                                        </tr>

                                        <tr class="table-active">
                                            <td>
                                                <p>6. Durante la sesión de Acompañamiento personalizado se dio espacio para solucionar consultas respecto de los contenidos del módulo. </p>
                                            </td>
                                            <td>
                                                <input type="radio" name="6" id="1" class="with-gap" [value]="1" [(ngModel)]="modalDataActaPM.datosEncuestaActaPM.evaluacion6"> SÍ
                                            </td>
                                            <td>
                                                <input type="radio" name="6" id="0" class="with-gap" [value]="0" [(ngModel)]="modalDataActaPM.datosEncuestaActaPM.evaluacion6"> NO
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>

                            </div>
                        </div>


                        <div class="row mt-3">
                            <div class="col-sm-12 ">
                                <p class="table-row-title">OBSERVACIONES DIRECTORA/ENCARGADA:</p>
                            </div>
                        </div>

                        <div class="row mt-3">
                            <div class="col-sm-12">
                                <textarea class="text-area-comentario" name="comentario" [(ngModel)]="modalDataActaPM.datosActa.observacionDirectora" #comentario='ngModel' style="background: #F5F6FC 0% 0% no-repeat padding-box;border-radius: 10px;opacity: 1;border: none;margin-bottom: 10px;width: 100%; height: 165px;padding: 10px;"></textarea>
                            </div>

                        </div>

                        <!-- <div class="errores" *ngIf="erores != ''" >
                        <p class="table-row-title " style="color: #D8000C;">{{ erores }}</p>
                        </div> -->

                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-send botonCalendario" style="margin: 5px;font-size: 16px;height: 45px;padding: 0px;" (click)="firmarActaPM(modalDataActaPM)">Firmar</button>
                        <button type="button" class="btn btn-send botonCalendario" style="margin: 5px;font-size: 16px;height: 45px;background-color: #30374B;padding: 0px;" data-bs-dismiss="modal" (click)="close()">Cerrar</button>
                    </div>
                </ng-template>


                <ng-template #modalRevisarActaPM let-modal>
                    <div class="modal-header" style="padding: 0px 23px;" width="100%">
                        <h5 id="modalTitleUser" style="text-align: left;font: normal normal bold 26px/53px Montserrat;letter-spacing: 0px;color: #EE366D;">Acta Sesión de Acompañamiento Personalizado </h5>
                        <button type="button" (click)="close()" style="background: none;border: none;font-size: xx-large;">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body" style="padding: 0px 50px;" width="100%">

                        <div class="row">
                            <div class="col-sm-12 mt-2" style="padding: 15px;">
                                <p style="text-align: left; letter-spacing: 0px; color: #30374B;opacity: 1;">
                                    La presente acta respalda la realización de la sesión de Acompañamiento personalizado llevada a cabo por la Unidad educativa <b>{{modalDataActa?.dataJardin?.jardin}}</b> como parte de la etapa de Capacitación de la
                                    8ª aplicación del Modelo de Gestión de Calidad de la Educación Parvularia.
                                </p>
                                <p>
                                    El acta que se presenta a continuación, sintetiza información relevante de la sesión realizada por la Unidad Educativa: <b>{{modalDataActa?.dataJardin?.jardin}}</b> como parte de la 8ª aplicación del Modelo de Gestión
                                    de la Calidad de la Educación Parvularia.
                                </p>
                            </div>
                        </div>

                        <div>
                            <div class="row mt-3">
                                <div class="col-sm-8 ">
                                    <p class="table-row-title">PARTICIPANTES Y SU ROL:</p>
                                </div>
                            </div>
                            <div class="row mt-3">
                                <div class="col-sm-12 ">
                                    <table class="table table-hover">
                                        <thead>
                                            <tr>
                                                <th scope="col">Participante</th>
                                                <th scope="col">Rol</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>{{modalDataActaPM.datosActa.nombreTutor}}</td>
                                                <td>Tutor/a</td>
                                            </tr>
                                            <tr>
                                                <td>{{modalDataActaPM.datosActa.nombreDirectora}}</td>
                                                <td>Directora</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>

                        <div class="row mt-3">
                            <div class="col-sm-12 ">
                                <p class="table-row-title">MÓDULOS CONTEMPLADOS:</p>
                            </div>
                        </div>

                        <div class="row mt-3">
                            <div class="col-sm-12 ">
                                <p style="text-align: left;
                        font: normal normal normal 16px/28px Hind Siliguri;
                        letter-spacing: 0px;
                        color: #4C4D55;
                        opacity: 1;">{{modalDataActaPM?.modulo}}</p>
                            </div>
                        </div>

                        <div class="row mt-3">
                            <div class="col-sm-12 ">
                                <p class="table-row-title">TIEMPOS:</p>
                                <p style="text-align: left;
                                font: normal normal normal 16px/28px Hind Siliguri;
                                letter-spacing: 0px;
                                color: #4C4D55;
                                opacity: 1;">Escriba la fecha, horario y duración de la Entrevista de validación:</p>
                            </div>
                        </div>


                        <div class="row mt-3">
                            <div class="col-sm-12 ">
                                <p style="display: inline-block;text-align: left;font: normal normal normal 16px/28px Hind Siliguri;letter-spacing: 0px;color: #4C4D55; opacity: 1;margin-left: 40px;">Fecha:</p>
                                <p style="padding: 8px 14px;display: inline-block;margin-left: 10px;background: #E8E8E8 0% 0% no-repeat padding-box; border-radius: 10px;">{{modalDataActaPM?.datosActa?.fechaInicio | date:'dd' }}</p>
                                <p style="padding: 8px 14px;display: inline-block;margin-left: 10px;background: #E8E8E8 0% 0% no-repeat padding-box; border-radius: 10px;">{{modalDataActaPM?.datosActa?.fechaInicio | date:'MM' }}</p>
                                <p style="padding: 8px 14px;display: inline-block;margin-left: 10px;background: #E8E8E8 0% 0% no-repeat padding-box; border-radius: 10px;">{{modalDataActaPM?.datosActa?.fechaInicio | date:'yyyy' }}</p>
                                <p style="display: inline-block;text-align: left;font: normal normal normal 16px/28px Hind Siliguri;letter-spacing: 0px;color: #4C4D55; opacity: 1;margin-left: 30px;">Inicio:</p>
                                <p style="padding: 8px 14px;display: inline-block;margin-left: 10px;background: #E8E8E8 0% 0% no-repeat padding-box; border-radius: 10px;">{{modalDataActaPM?.datosActa?.fechaInicio | date:'HH:mm' }}</p>
                                <p style="display: inline-block;text-align: left;font: normal normal normal 16px/28px Hind Siliguri;letter-spacing: 0px;color: #4C4D55; opacity: 1;margin-left: 30px;">Término:</p>
                                <p style="padding: 8px 14px;display: inline-block;margin-left: 10px;background: #E8E8E8 0% 0% no-repeat padding-box; border-radius: 10px;">{{modalDataActaPM?.datosActa?.fechaFin | date:'HH:mm' }}</p>
                            </div>
                        </div>

                        <div class="row mt-3">
                            <div class="col-sm-12 ">
                                <p class="table-row-title">OBSERVACIONES TUTOR:</p>
                            </div>
                        </div>

                        <div class="row mt-3">
                            <div class="col-sm-12">
                                <textarea class="text-area-comentario" disabled [(ngModel)]="modalDataActaPM.datosActa.observacionTutor" style="background: #F5F6FC 0% 0% no-repeat padding-box;border-radius: 10px;opacity: 1;border: none;margin-bottom: 10px;width: 100%; height: 165px;padding: 10px;"></textarea>
                            </div>

                        </div>

                        <div class="row mt-3">
                            <div class="col-sm-12 ">
                                <p class="table-row-title">EVALUACIÓN DE LA SESIÓN</p>
                            </div>
                        </div>


                        <div class="row mt-3">
                            <div class="col-sm-12 ">

                                <table class="table table-hover">

                                    <tbody>

                                        <tr>
                                            <td>
                                                <p>1. La sesión de Acompañamiento personalizado se desarrolló en un clima de respeto y diálogo. </p>
                                            </td>
                                            <td>
                                                <input type="radio" name="1" id="1" class="with-gap" [value]="1" [(ngModel)]="modalDataActaPM.datosEncuestaActaPM.evaluacion1" disabled> SÍ
                                            </td>
                                            <td>
                                                <input type="radio" name="1" id="2" class="with-gap" [value]="0" [(ngModel)]="modalDataActaPM.datosEncuestaActaPM.evaluacion1" disabled> NO
                                            </td>
                                        </tr>

                                        <tr class="table-active">
                                            <td>
                                                <p>2. El tutor/a presenta conocimiento sobre todos los contenidos del módulo. </p>
                                            </td>
                                            <td>
                                                <input type="radio" name="2" id="1" class="with-gap" [value]="1" [(ngModel)]="modalDataActaPM.datosEncuestaActaPM.evaluacion2" disabled> SÍ
                                            </td>
                                            <td>
                                                <input type="radio" name="2" id="0" class="with-gap" [value]="0" [(ngModel)]="modalDataActaPM.datosEncuestaActaPM.evaluacion2" disabled> NO
                                            </td>
                                        </tr>

                                        <tr>
                                            <td>
                                                <p>3. La sesión de Acompañamiento personalizado se realiza a través de una metodología activa y de participación.</p>
                                            </td>
                                            <td>
                                                <input type="radio" name="3" id="1" class="with-gap" [value]="1" [(ngModel)]="modalDataActaPM.datosEncuestaActaPM.evaluacion3" disabled> SÍ
                                            </td>
                                            <td>
                                                <input type="radio" name="3" id="0" class="with-gap" [value]="0" [(ngModel)]="modalDataActaPM.datosEncuestaActaPM.evaluacion3" disabled> NO
                                            </td>
                                        </tr>

                                        <tr class="table-active">
                                            <td>
                                                <p>4. El tutor/a retroalimenta mencionando fortalezas y aspectos a mejorar en base a los ejercicios prácticos del módulo. </p>
                                            </td>
                                            <td>
                                                <input type="radio" name="4" id="1" class="with-gap" [value]="1" [(ngModel)]="modalDataActaPM.datosEncuestaActaPM.evaluacion4" disabled> SÍ
                                            </td>
                                            <td>
                                                <input type="radio" name="4" id="0" class="with-gap" [value]="0" [(ngModel)]="modalDataActaPM.datosEncuestaActaPM.evaluacion4" disabled> NO
                                            </td>
                                        </tr>

                                        <tr>
                                            <td>
                                                <p>5. Al inicio de la sesión de Acompañamiento personalizado se declaran los objetivos que orientan el trabajo del módulo. </p>
                                            </td>
                                            <td>
                                                <input type="radio" name="5" id="1" class="with-gap" [value]="1" [(ngModel)]="modalDataActaPM.datosEncuestaActaPM.evaluacion5" disabled> SÍ
                                            </td>
                                            <td>
                                                <input type="radio" name="5" id="0" class="with-gap" [value]="0" [(ngModel)]="modalDataActaPM.datosEncuestaActaPM.evaluacion5" disabled> NO
                                            </td>
                                        </tr>

                                        <tr class="table-active">
                                            <td>
                                                <p>6. Durante la sesión de Acompañamiento personalizado se dio espacio para solucionar consultas respecto de los contenidos del módulo. </p>
                                            </td>
                                            <td>
                                                <input type="radio" name="6" id="1" class="with-gap" [value]="1" [(ngModel)]="modalDataActaPM.datosEncuestaActaPM.evaluacion6" disabled> SÍ
                                            </td>
                                            <td>
                                                <input type="radio" name="6" id="0" class="with-gap" [value]="0" [(ngModel)]="modalDataActaPM.datosEncuestaActaPM.evaluacion6" disabled> NO
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>

                            </div>
                        </div>


                        <div class="row mt-3">
                            <div class="col-sm-12 ">
                                <p class="table-row-title">OBSERVACIONES DIRECTORA/ENCARGADA:</p>
                            </div>
                        </div>

                        <div class="row mt-3">
                            <div class="col-sm-12">
                                <textarea class="text-area-comentario" name="comentario" disabled [(ngModel)]="modalDataActaPM.datosActa.observacionDirectora" #comentario='ngModel' style="background: #F5F6FC 0% 0% no-repeat padding-box;border-radius: 10px;opacity: 1;border: none;margin-bottom: 10px;width: 100%; height: 165px;padding: 10px;"></textarea>
                            </div>

                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-send botonCalendario" style="margin: 5px;font-size: 16px;height: 45px;background-color: #30374B;padding: 0px;" data-bs-dismiss="modal" (click)="close()">Cerrar</button>
                    </div>
                </ng-template>